import { PolygraphyProductUrlType } from '../../../../../../../services/exports/Constants';

export default {
  form: {
    url_type: {
      options: {
        [PolygraphyProductUrlType.OnlineShop]: 'Online shop',
        [PolygraphyProductUrlType.Storefront]: 'Storefront',
        [PolygraphyProductUrlType.Custom]: 'Custom',
      },
    },
  },
  labels: {
    save_changes_to_see_preview: 'Save changes to see the preview',
  },
  buttons: {
    save_and_preview: 'Save and preview',
  },
  toasts: {
    failed_to_load_data: 'Failed to load product',
    failed_to_save_changes: 'Failed to save changes!',
    changes_got_saved: 'Changes got saved!',
  },
};
